import React from 'react';

import HowBrandWorksSection from '@rover/react-lib/src/components/HowBrandWorksSection';
import {
  PageSectionId,
  useSectionRef,
} from '@rover/react-lib/src/pages/landing/SeoLocation/hooks/useSectionRef';
import { PetType } from '@rover/types/src/Pet';

interface SeoHowBrandWorksProps {
  serviceTypeName?: string;
  providerNounPlural?: string;
  petType?: PetType;
}

const SeoHowBrandWorks = ({
  serviceTypeName,
  providerNounPlural,
  petType,
}: SeoHowBrandWorksProps): JSX.Element => {
  const sectionRef = useSectionRef(PageSectionId.HowBrandWorks);

  return (
    <HowBrandWorksSection
      serviceTypeName={serviceTypeName}
      providerNounPlural={providerNounPlural}
      petType={petType}
      htmlRef={sectionRef}
      headingVariant="heading"
    />
  );
};

export default SeoHowBrandWorks;
